export default __webpack_public_path__ + "static/genesis_banner_bg-32735d2961b9040f5ae7d034e54eb715.png";